/* ValidateViewRenderer.js */

"use strict";
const _ = require("lodash");
const FileName = require("@gluenetworks/steve_utilities").fileName;
class ValidateViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("validate-view-gl");
        this._rootElem.component = this._model;
        this._validateDisplay = document.createElement("validate-display-gl");
        this._rootElem.appendChild(this._validateDisplay);
        this._logFile = "";
        this._logFileStarttime = undefined;
        this._viewActionsAdded = false;
        this._fileNamer = FileName;
        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        this._registerRemoveAction();
        this._unregisterListeners();
        this._model = undefined;
        this._rootElem.remove();
        this._logFile = "";
        this._validateDisplay.innerHTML = "";
        this._validateDisplay = undefined;
        return Promise.resolve();
    }
    _registerViewActions() {
        if (!this._viewActionsAdded) {
            this._model.gameEditor.addViewAction({
                type: "normal",
                displayName: "Validate Plan",
                name: "ValidateViewPlan",
                handler: (this._onValidatePlan = this._onValidatePlan.bind(this)),
            });
            this._model.gameEditor.addViewAction({
                type: "normal",
                displayName: "Stop Validation",
                name: "StopValidation",
                handler: (this._onStopValidation = this._onStopValidation.bind(this)),
            });
            this._model.gameEditor.addViewAction({
                type: "normal",
                displayName: "Download",
                name: "download",
                handler: (this._onDownloadButton = this._onDownloadButton.bind(this)),
            });
            this._viewActionsAdded = true;
        }
        this._model._gameEditor.hideViewAction("ValidationLogs");
        if (this._model._plan.status === "VALIDATING") {
            this._disableValidatePlan();
            this._enableStopValidation();
            this._disableDownload();
        } else {
            this._enableDisableValidatePlan();
            this._disableStopValidation();
            this._enableDownload();
        }
        if (
            this._model._plan.status === "BUNDLED" ||
            this._model._plan.status === "UPGRADE_COMPLETE"
        ) {
            this._disableValidatePlan();
        }
        this._model._planDetails._modalUserFeedback.hideDisplayed();
        return Promise.resolve();
    }
    _registerRemoveAction() {
        this._removeViewActions();
    }
    _removeViewActions() {
        this._model.gameEditor.removeViewAction("StopValidation");
        this._model.gameEditor.removeViewAction("ValidateViewPlan");
        this._model.gameEditor.removeViewAction("download");
        Promise.resolve();
    }
    _toggleAction() {
        let results = this._model._validateDetails;
        if (results.summary.startTime && results.summary.endTime) {
            this._model.gameEditor.disableViewAction("StopValidation");
        } else {
            this._model.gameEditor.disableViewAction("ValidateViewPlan");
        }
    }

    _enableDisableValidatePlan(status) {
        if (!status) {
            status = this._model._plan.getStatus();
        }
        if (this.model) {
            const validateViewPlanButton =
                this.model.gameEditor._viewContainerElem.nextElementSibling.lastElementChild.querySelectorAll(
                    "button-control[value='ValidateViewPlan']"
                );
            const validatePlanButton =
                this.model.gameEditor._viewContainerElem.nextElementSibling.lastElementChild.querySelectorAll(
                    "button-control[value='ValidatePlan']"
                );
            if (status === "VALIDATING") {
                this._disableDownload();
                _.get(validateViewPlanButton, 0, validateViewPlanButton).innerHTML =
                    "Validating...";
                _.get(validatePlanButton, 0, validatePlanButton).innerHTML = "Validating...";
            } else {
                this._enableDownload();
                _.get(validateViewPlanButton, 0, validateViewPlanButton).innerHTML =
                    "Validate Plan";
                _.get(validatePlanButton, 0, validatePlanButton).innerHTML = "Validate Plan";
            }
        }
    }

    _disableAllValidateAction() {
        this._disableValidatePlan();
        this._disableDownload();
        this._disableStopValidation();
    }

    _disableStopValidation() {
        this.model.gameEditor.disableViewAction("StopValidation");
    }

    _enableStopValidation() {
        if (!_.isEmpty(this._model)) {
            this.model.gameEditor.enableViewAction("StopValidation");
        }
    }

    _disableDownload() {
        this.model.gameEditor.disableViewAction("download");
    }

    _enableDownload() {
        this.model.gameEditor.enableViewAction("download");
    }

    _disableValidatePlan() {
        this._model.gameEditor.disableViewAction("ValidateViewPlan");
    }

    _enableValidatePlan() {
        this._model.gameEditor.enableViewAction("ValidateViewPlan");
    }

    _registerListeners() {
        this._model.on("LogAdded", (this._onLogAdded = this._onLogAdded.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeAllListeners("LogAdded");
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    async render() {
        try {
            this._logFile = "";
            this._validateDisplay.innerHTML = "";
            this._registerViewActions();
            await this._model.whenModelIsReady();
            return;
        } catch (err) {
            this._validateDisplay.innerHTML =
                err.errorMsg || "Error fetching IoT OS Plan Validation Logs. Please try again.";
            this._model._logger.warn(err, "IoTOsPlanDetailsViewRenderer.render() error");
            return err;
        }
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onLogAdded(log) {
        this._appendLog(log);
        this._validateDisplay.scrollTop = this._validateDisplay.scrollHeight;
    }

    _onDownloadButton() {
        if (!_.isEmpty(this._logFile)) {
            this.model.gameEditor.disableViewAction("download");
            //let fileName = this._model._plan.name + " " + this._logFileStarttime + ".txt";
            let fileName = this._fileNamer({
                solution: "OSM",
                general: "PlanValidationLog",
                specific: this._model._plan.name,
                date: this._logFileStarttime,
                suffix: "txt",
            });
            this._model.io.fileFactory.saveStringAsFile(this._logFile, fileName);
            this.model.gameEditor.enableViewAction("download");
        }
    }
    _onValidatePlan() {
        return this.render();
    }
    _onStopValidation() {
        this._model.stopValidation();
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    _appendLog(log) {
        let logFileLine = [];
        let logEntry = document.createElement("p");
        let timestamp = _.get(log, "time", undefined);
        let fileTimeStamp = timestamp;
        if (!_.isUndefined(timestamp)) {
            fileTimeStamp = Date.create(timestamp).format("{yyyy}-{MM}-{dd}T{HH}:{mm}:{ss}.{fff}");
            timestamp = Date.create(timestamp).format("{HH}:{mm}:{ss}.{fff}");
        } else {
            timestamp = "";
        }
        let time = document.createElement("span");
        time.classList.add("timestamp");
        time.innerHTML = timestamp;
        logFileLine.push(timestamp);
        if (!this._logFileStarttime) {
            this._logFileStarttime = fileTimeStamp;
        }
        let message = document.createElement("span");
        message.classList.add("message");
        let msg = _.get(log, "msg", "");
        message.innerHTML = msg;
        logFileLine.push(msg);
        logEntry.appendChild(time);
        logEntry.appendChild(message);
        this._validateDisplay.appendChild(logEntry);
        this._logFile += logFileLine.join(" ") + "\n";
    }
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = ValidateViewRenderer;
